import { Overlay } from '../../components/overlay/overlay';

class DownloadsZoomshot {
    constructor (element, settings) {
        this.$downloadZoomshot = element;
        this.$parent = document.querySelector('.downloads');
        this.stackImage = this.$downloadZoomshot.querySelector('[data-download-zoomshot="image"]');
        this.stackButton = this.$downloadZoomshot.querySelector('[data-download-zoomshot="button"]');
        this.stackContentUrl = this.$downloadZoomshot.getAttribute('data-download-ajax-url');
        this.$overlay = this.$parent?.querySelector('[data-overlay="root"]');
        this.$overlayContent = this.$overlay.querySelector('.overlay__content');
    }

    initialize () {
        if (this.$overlay) {
            this.overlay = new Overlay(this.$overlay);
            this.overlay.initialize();
            this.bindEvents();
        }
    }

    // set event for all triggers (ex. download button, image, overlay close)
    bindEvents () {
        this.stackImage.addEventListener('click', () => {
            this.overlay.showOverlay();
            this.getDownloadContent();
        });

        this.stackButton.addEventListener('click', () => {
            this.overlay.showOverlay();
            this.getDownloadContent();
        });

        this.overlay.$close.addEventListener('click', () => {
            this.removeDownloadContentFromOverlay();
        });

        document.addEventListener('keyup', (e) => {
            if (e.key === 'Escape' && this.$overlay.classList.contains('overlay--visible')) {
                this.overlay.hideOverlay();
                this.removeDownloadContentFromOverlay();
            }
        });
    }

    // get download content via ajax and place it
    getDownloadContent () {
        fetch(encodeURI(this.stackContentUrl)).then((response) => {
            if (response.ok) {
                return response.text();
            } else {
                return Promise.reject(response);
            }
        }).then((data) => {
            this.setDownloadContentToOverlay(data);
        }).catch((err) => {
            // show warning in console when error
            console.warn('Something went wrong while getting Download Content: ', err);
        });
    }

    // remove content from overlay
    removeDownloadContentFromOverlay () {
        this.$overlayContent.innerHTML = '';
    }

    // set content
    setDownloadContentToOverlay (data) {
        this.$overlayContent.innerHTML = data;
    }
}

export { DownloadsZoomshot };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $$roots = $context.querySelectorAll('[data-download-zoomshot="root"]');
        $$roots.forEach($root => {
            const $rootAPI = new DownloadsZoomshot($root);
            $rootAPI.initialize();
        });
    }
});
